import { AutoComplete } from "antd";
import { useState } from "react";

import "./SearchBox.scss";
import { useNavigate } from "react-router-dom";
import { useProjectOptions } from "projects/queries";
import { useBoundStore } from "store";
import { SearchOutlined } from "@ant-design/icons";
import { buildOrganizationSectionPath } from "shared/utils/paths";

export const SearchBox = () => {
  const navigate = useNavigate();
  const { currentOrganization } = useBoundStore();
  const [search, setSearch] = useState<string>("");
  const { data = [] } = useProjectOptions(currentOrganization?.id, search);

  const handleSearch = (value: string) => {
    setSearch(value);
  };

  const handleSelect = (value: string) => {
    setSearch("");
    navigate(buildOrganizationSectionPath(currentOrganization, `projects/${value}`));
  };

  return (
    <AutoComplete
      data-testid='projectsearchbox'
      className='search-box-input-container'
      value={search}
      options={data}
      onSearch={handleSearch}
      onSelect={handleSelect}
      placeholder='Search for a project'
      size='middle'
      suffixIcon={<SearchOutlined />}
      variant='borderless'
    />
  );
};
